<template>
  <span>
    <span style="text-decoration: underline" class="show-tooltip">
      {{ title }}
      <i class="fa fa-question-circle"></i>
    </span>
    <span class="tooltip-text" :style="textStyles" v-html="text"> </span>
  </span>
</template>

<script>
export default {
  name: 'SimpleTooltip',
  props: {
    text: {
      type: String,
      require: true,
      default: () => '',
    },
    textStyles: {
      type: String,
      require: true,
      default: () => '',
    },
    titleStyles: {
      type: String,
      require: true,
      default: () => '',
    },
    title: {
      type: String,
      require: true,
      default: () => '',
    },
  },
}
</script>

<style>
.tooltip-text {
  font-size: 16px;
  visibility: hidden;
  visibility: hidden;
  width: 100%;
  background-color: black;
  color: #fff;
  text-align: center;
  border-radius: 6px;
  padding: 5px 0;

  /* Position the tooltip */
  position: absolute;
  z-index: 1;
  top: 100%;
  left: 50px;
  margin-left: -60px;
}
.fa-question-circle:hover + .tooltip-text {
  visibility: visible;
}
.show-tooltip:hover + .tooltip-text {
  visibility: visible;
}
@media only screen and (max-width: 768px) {
  .tooltip-text {
    left: 60px !important;
  }
}
</style>
